import { satelliteStyle, VECTOR_MAX_ZOOM } from './shared'
import type { BasemapProvider, BasemapStyle, BasemapStyleRequest } from './types'

/*
 * OpenFreeMap — the street basemap.
 *
 * WHY THIS ONE
 * It needs no API key, sets no usage limits, and permits commercial use, so
 * there is nothing to revoke, meter or watermark against us. Its Positron and
 * Dark styles share a lineage with CARTO's, so this is the same look GeoBorder
 * has always had.
 *
 * The tradeoff, accepted deliberately: it is run by one person and funded by
 * donations, with no SLA offered. If that becomes untenable, `index.ts`
 * documents the switch to CARTO, and the durable answer beyond that is
 * self-hosting a Protomaps PMTiles extract.
 */

const OFM_LIGHT_STYLE = 'https://tiles.openfreemap.org/styles/positron'
const OFM_DARK_STYLE = 'https://tiles.openfreemap.org/styles/dark'

/** OpenFreeMap requires attribution to itself, OpenMapTiles and OSM. */
export const OFM_ATTRIBUTION =
  '<a href="https://openfreemap.org" target="_blank" rel="noopener">© OpenFreeMap</a> · <a href="https://openmaptiles.org/" target="_blank" rel="noopener">© OpenMapTiles</a> · <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">© OpenStreetMap</a>'

function getStyle({ theme, kind }: BasemapStyleRequest): BasemapStyle {
  if (kind === 'satellite') return satelliteStyle()
  return {
    style: theme === 'dark' ? OFM_DARK_STYLE : OFM_LIGHT_STYLE,
    attribution: OFM_ATTRIBUTION,
    maxZoom: VECTOR_MAX_ZOOM,
  }
}

export const openFreeMapProvider: BasemapProvider = {
  name: 'openfreemap+esri',
  getStyle,
}
